import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
// styles
import { HeaderStyled, TitleStyled } from "./styles";
// Components
import CloseButton from "./CloseButton";
var Header = function (_a) {
    var _b = _a.headerHeight, headerHeight = _b === void 0 ? "77px" : _b, title = _a.title, children = _a.children, onClose = _a.onClose;
    return (_jsxs(HeaderStyled, { headerHeight: headerHeight, children: [title && _jsx(TitleStyled, { headerHeight: headerHeight, children: title }), children, !children && _jsx(CloseButton, { onClick: onClose })] }));
};
export default Header;
